import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import React, {Fragment, useEffect, useState} from "react";
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import {makeStyles} from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {API} from "aws-amplify";


const useStyles = makeStyles((theme) => ({
    FormControl: {
        width: 550
    },
    fab: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    alignLeft: {
        float: "left"
    },
    alignRight: {
        float: "right"
    },
    textBox: {
        padding: "25px 0"
    },
    paymentTable: {
        width: "100%"
    }
}));

export const MSE_TESORERIA_PAYMENTS_CONCEPTS_MODAL = [
    {value: "CEDAR_SECU_LIBROS", description: "CEDAR_SECU_LIBROS", price: 1800},
    {value: "CEDAR_PREPA_LIBROS", description: "CEDAR_PREPA_LIBROS", price: 1800},
    {value: "CEDAR_SECU_INSCRIPCION", description: "CEDAR_SECU_INSCRIPCION", price: 1800},
    {value: "CEDAR_PREPA_INSCRIPCION", description: "CEDAR_PREPA_INSCRIPCION", price: 1800},
    {value: "CEDAR_SECU_REINSCRIPCION", description: "CEDAR_SECU_REINSCRIPCION", price: 1800},
    {value: "CEDAR_PREPA_REINSCRIPCION", description: "CEDAR_PREPA_REINSCRIPCION", price: 1800},
    {value: "CEDAR_SECU_CUOTA_ANUAL", description: "CEDAR_SECU_CUOTA_ANUAL", price: 1800},
    {value: "CEDAR_PREPA_CUOTRA_ANUAL", description: "CEDAR_PREPA_CUOTRA_ANUAL", price: 1800},
    {value: "CEDAR_SECU_COLEGIATURA_10", description: "CEDAR_SECU_COLEGIATURA_10", price: 1800},
    {value: "CEDAR_PREPA_COLEGIATURA_10", description: "CEDAR_PREPA_COLEGIATURA_10", price: 2280},
    {value: "CEDAR_SECU_COLEGIATURA_12", description: "CEDAR_SECU_COLEGIATURA_12", price: 1500},
    {value: "CEDAR_PREPA_COLEGIATURA_12", description: "CEDAR_PREPA_COLEGIATURA_12", price: 1900},
    {value: "CEDAR_SECU_GASTOS FINALES", description: "CEDAR_SECU_GASTOS FINALES", price: 2000},
    {value: "CEDAR_PREPA_GASTOS FINALES", description: "CEDAR_PREPA_GASTOS FINALES", price: 3000},
    {value: "UVT_COLEGIATURA", description: "UVT_COLEGIATURA", price: 1400},
    {value: "UVT_INSCRIPCION", description: "UVT_INSCRIPCION", price: 1000},
    {value: "UVT_REINSCRIPCION", description: "UVT_REINSCRIPCION", price: 1400},
    {value: "UVT_ENF_COLEGIATURA", description: "UVT Enfermería Colegiatura", price: 1400},
    {value: "UVT_ENF_INSCRIPCION", description: "UVT Enfermería Inscripción", price: 1800},
    {value: "UVT_ENF_REINSCRIPCION", description: "UVT Enfermería Reinscripción", price: 1800},
    {value: "UVT_ENF_EXTRAORDINARIO", description: "UVT Enfermería Extraordinario", price: 500},
    {value: "UVT_MAESTRIA_COLEGIATURA", description: "UVT Maestría Colegiatura", price: 1500},
    {value: "UVT_MAESTRIA_INSCRIPCION", description: "UVT Maestría Inscripción", price: 1500},
    {value: "UVT_MAESTRIA_REINSCRIPCION", description: "UVT Maestría Re-inscripción", price: 1500},
];

export const MSE_FRIENDLY_MONTHS = {
    "01": "Enero",
    "02": "Febrero",
    "03": "Marzo",
    "04": "Abril",
    "05": "Mayo",
    "06": "Junio",
    "07": "Julio",
    "08": "Agosto",
    "09": "Septiembre",
    "10": "Octubre",
    "11": "Noviembre",
    "12": "Diciembre",
}

export default function ModalMultiplePayments({student, setIsLoading, onPaymentAdded}) {
    const classes = useStyles();
    const [openModal, setOpenModal] = useState(false);
    const [payment, setPayment] = useState({concept: "UVT_INSCRIPCION"});
    let MSE_DATE_OPTIONS = createDateOptions();

    const createPaymentApi = () => {
        const body = {
            ...payment,
            moneyTotal: payment.moneyTotal || "0",
            price: getPriceForCurrentConceptRaw(),
            studentUuid: window.location.pathname.split("/students/").pop()
        };
        return API.post("misServiciosEscolares", "/tesoreria/payments?multiplePayments=true", {
            body: body
        });
    };

    const handleSubmit = async () => {
        console.log(payment, "payment");
        clearPaymentAndCloseModal()
        setIsLoading(true);
        try {
            const createdPayment = await createPaymentApi()
            onPaymentAdded(createdPayment, true);
        } catch (e) {
            console.log(e);
            alert("No se pudo generar el pago, por favor intente de nuevo");
        } finally {
            setIsLoading(false);
        }
    };


    function createDateOptions() {
        let temp = [];
        const currentYear = new Date().getFullYear();
        const gap = 7;
        for (let i = 0; i < gap + 3; i++) {
            for (let j = 0; j < 12; j++) {
                temp.push(j < 9
                        ? `0${j + 1}-${currentYear - gap + i}`
                        : `${j + 1}-${currentYear - gap + i}`
                );
            }
        }
        return temp;
    }

    function getPriceForCurrentConceptRaw() {
        if (!payment?.concept) {
            return -1;
        }
        const index = MSE_TESORERIA_PAYMENTS_CONCEPTS_MODAL.findIndex(o => o.value === payment.concept);
        return MSE_TESORERIA_PAYMENTS_CONCEPTS_MODAL[index].price;
    }

    const clearPaymentAndCloseModal = () => {
        setOpenModal(false);
        setPayment({concept: "UVT_INSCRIPCION"});
    };

    return (
        <div className="ModalNewStudent">
            <Button
                variant="contained"
                color="primary"
                onClick={() => setOpenModal(true)}>
                Crear Múltiples Pagos
            </Button>
            <Fragment>
                <Dialog open={openModal} onClose={clearPaymentAndCloseModal} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Crear Múltiples Pagos</DialogTitle>
                    <DialogContent>
                        <FormControl className={classes.FormControl}>
                            <InputLabel id="mse-tesoreria-concept-type-input-label-id">
                                Concepto de Pago (requerido)
                            </InputLabel>
                            <Select
                                labelId="mse-tesoreria-concept-label-id"
                                id="mse-tesoreria-concept-id"
                                value={payment.concept}
                                required
                                className={classes.FormControl}
                                onChange={e => setPayment({...payment, concept: e.target.value})}
                            >
                                {MSE_TESORERIA_PAYMENTS_CONCEPTS_MODAL.map(o => {
                                    return <MenuItem key={o.value} value={o.value}>{o.description}</MenuItem>;
                                })}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.FormControl}>
                            <InputLabel id="mse-tesoreria-multiple-concept-type-input-label-id">
                                Fechas de Pagos
                            </InputLabel>
                            <Select
                                labelId="mse-tesoreria-multiple-concept-label-id"
                                id="mse-tesoreria-multiple-concept-id"
                                value={payment.conceptDates}
                                defaultValue={[]}
                                required
                                multiple
                                className={classes.FormControl}
                                onChange={e => setPayment({...payment, conceptDates: e.target.value})}
                            >
                                {MSE_DATE_OPTIONS.map(o => {
                                    return <MenuItem key={o} value={o}>{MSE_FRIENDLY_MONTHS[o.split("-")[0]]}-{o.split("-")[1]}</MenuItem>;
                                })}
                            </Select>
                        </FormControl>
                        <TextField
                            required
                            fullWidth
                            margin="dense"
                            id="reference"
                            label="Referencia (opcional)"
                            value={payment.reference || ""}
                            onChange={e => setPayment({...payment, reference: e.target.value})}
                            className={classes.FormControl}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={clearPaymentAndCloseModal}
                            color="primary"
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleSubmit}
                            color="primary"
                        >
                            Crear Pago
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        </div>
    );
};